import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { TranslocoRootModule } from 'app/transloco-root.module';
import { IgntrIconComponent, IconName } from 'app/shared/igntr';
import { DashboardCardComponent } from './dashboard-card.component';

export interface TaskRowView {
  kind: string;
  labelKey: string;
  count: number;
  subKey?: string;
  subText?: string;
  icon: IconName;
  accent: string;
  link?: string;
}

@Component({
  selector: 'app-dashboard-tasks-summary',
  standalone: true,
  imports: [
    CommonModule,
    RouterModule,
    TranslocoRootModule,
    IgntrIconComponent,
    DashboardCardComponent,
  ],
  template: `
    <app-dashboard-card
      [title]="'dashTasksTitle' | transloco"
      [sub]="totalText"
    >
      @if (tasks.length === 0) {
        <div class="text-[14px] text-slate-400 py-6 text-center">
          {{ 'dashTasksEmpty' | transloco }}
        </div>
      } @else {
        <div class="space-y-[6px]">
          @for (t of tasks; track t.kind) {
            <a
              [routerLink]="t.link || null"
              class="group w-full flex items-center gap-3 p-2.5 rounded-lg hover:bg-slate-50 text-left transition-colors"
            >
              <div
                class="w-9 h-9 rounded-lg flex items-center justify-center text-white shrink-0"
                [style.backgroundColor]="t.accent"
              >
                <igntr-icon [name]="t.icon" [size]="16"></igntr-icon>
              </div>
              <div class="flex-1 min-w-0">
                <div class="text-[14px] font-semibold text-slate-900 truncate">
                  {{ t.labelKey | transloco }}
                </div>
                <div class="text-[14px] text-slate-500 truncate">
                  {{ t.subKey ? (t.subKey | transloco) : t.subText }}
                </div>
              </div>
              <span
                class="text-[14px] font-mono tabular-nums px-1.5 py-0.5 rounded bg-slate-100 text-slate-700 group-hover:bg-accent/15 group-hover:text-accent-deep transition-colors"
              >
                {{ t.count }}
              </span>
              <span
                class="text-slate-300 group-hover:text-accent transition-colors"
              >
                <igntr-icon name="chevronR" [size]="16"></igntr-icon>
              </span>
            </a>
          }
        </div>
      }
    </app-dashboard-card>
  `,
})
export class DashboardTasksSummaryComponent {
  @Input() tasks: TaskRowView[] = [];

  get totalText(): string {
    const total = this.tasks.reduce((s, t) => s + t.count, 0);
    return `${total}`;
  }
}
